import { render, staticRenderFns } from "./ScrollLoad.vue?vue&type=template&id=b9a09432&scoped=true"
import script from "./ScrollLoad.vue?vue&type=script&lang=js"
export * from "./ScrollLoad.vue?vue&type=script&lang=js"
import style0 from "./ScrollLoad.vue?vue&type=style&index=0&id=b9a09432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a09432",
  null
  
)

export default component.exports